module.exports = __webpack_public_path__ + "static/img/loading-bg.906ba13.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/loading-bg.png
// module id = TtcW
// module chunks = 1